export const DEFINITION_ROUTE = {
  name: 'Definition',
  path: 'definition',
};
